import { useIntl } from 'react-intl';
import TooltipComponent from '../../TooltipComponent';
import InfoTooltip from './InfoTooltip';
import { ITripsOverViewRecord } from '../interfaces';

interface IInfoForRideProps {
  data: ITripsOverViewRecord;
  datacyIndex: number;
}

function InfoForParking(props: IInfoForRideProps) {
  const { formatMessage: f } = useIntl();
  return (
    <div
      className="align-middle col-parking"
      style={{ minWidth: '130px', flex: 1, textAlign: 'right', cursor: 'pointer' }}
    >
      <TooltipComponent
        overlay={
          <InfoTooltip
            event={props.data.parking ? Number(props.data.parking.summary.event) : 0}
            alarm={props.data.parking ? Number(props.data.parking.summary.alarm) : 0}
            tag={props.data.parking ? Number(props.data.parking.summary.tag) : 0}
            comment={props.data.parking ? Number(props.data.parking.summary.comment) : 0}
            waypoint={props.data.parking ? Number(props.data.parking.summary.waypoint) : 0}
            datacyIndex={props.datacyIndex}
          />
        }
        width="208px"
        firstItems
        positionLeft
        bottom="48px"
      >
        <div data-cy={`row-${props.datacyIndex + 1}-parkingInfo`}>
          {props.data.parking?.duration
            ? props.data.parking.duration
            : f({ id: 'tables.tripsOverview.column.datetime.anonymized' })}
        </div>
        <div>
          <span
            data-cy={`row-${props.datacyIndex + 1}-parkingInfo_Waypoint`}
            className="mx-2px text-c-green-dark"
          >
            {props.data.parking && String(props.data.parking.summary.waypoint) === '-' ? (
              <>&ndash;</>
            ) : (
              props.data.parking?.summary.waypoint
            )}
          </span>
          /
          <span
            data-cy={`row-${props.datacyIndex + 1}-parkingInfo_Event`}
            className="mx-2px text-violet-dark"
          >
            {props.data.parking && String(props.data.parking.summary.event) === '-' ? (
              <>&ndash;</>
            ) : (
              props.data.parking?.summary.event
            )}
          </span>
          /
          <span
            data-cy={`row-${props.datacyIndex + 1}-parkingInfo_Alarm`}
            className="mx-2px text-c-red"
          >
            {props.data.parking && String(props.data.parking.summary.alarm) === '-' ? (
              <>&ndash;</>
            ) : (
              props.data.parking?.summary.alarm
            )}
          </span>
          /
          <span
            data-cy={`row-${props.datacyIndex + 1}-parkingInfo_Tag`}
            className="mx-2px text-c-orange"
          >
            {props.data.parking?.summary.tag}
          </span>
          /
          <span
            data-cy={`row-${props.datacyIndex + 1}-parkingInfo_Comment`}
            className="mx-2px text-c-blue-dark"
          >
            {props.data.parking?.summary.comment}
          </span>
        </div>
      </TooltipComponent>
    </div>
  );
}

export default InfoForParking;
